import React from 'react'
import styles from './LeaderBoard.module.sass'
import {shortAddress} from "../../../core/helpers";
import {defaultScan} from "../../../config";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import cn from "classnames";

export function LeaderBoard({ leaderBoard, balances }) {
    return (
        <div className={cn(styles.wrap, styles.wrap_top)}>
            <img src="images/cnr-logo.jpg" className={styles.icon} alt="logo cnr" />
            {/*<Icon className={styles.icon} />*/}
            <div>
                <div className={styles.balance}>
                    <span className={styles.amount}>{(balances?.bonusRewardPool * 0.4).toFixed(2)}</span>
                    <span className={styles.cur}> CNR</span>
                </div>
                {/* <div className={styles.percents}>
                    Bonus Reward Pool
                </div> */}
                <div className={styles.percents}>
                    40% of Bonus Reward Pool
                </div>
            </div>
            <div className={styles.header}>
                <div className={styles.simple_top}>Leaderboard</div>
            </div>
            <Table>
                <Thead>
                    <Tr className={styles.tr}>
                        <Th>Address</Th>
                        {/*<Th>Hash</Th>
                        <Th>BlockNumber</Th>*/}
                        <Th>Deposit</Th>
                        <Th>Reward</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {leaderBoard?.list?.map((i, it) => {
                        return (
                            <Tr className={styles.tr} key={i.address + it + i.txHash}>
                                <Td>
                                    <a
                                        href={`${defaultScan}/address/${i.address}`}
                                        className={styles.td_link}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {i.address}
                                    </a>
                                    <a
                                        href={`${defaultScan}/address/${i.address}`}
                                        className={styles.td_link_short}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {shortAddress(i.address)}
                                    </a>
                                </Td>
                                {/*<Td>
                                    <a
                                        href={`${defaultScan}/tx/${i.txHash}`}
                                        className={styles.td_link}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {i.txHash}
                                    </a>
                                    <a
                                        href={`${defaultScan}/tx/${i.txHash}`}
                                        className={styles.td_link_short}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {shortAddress(i.txHash)}
                                    </a>
                                </Td>*/}
                                {/*<Td className={styles.td_amount}>
                                    {i.blockNumber}
                                </Td>*/}
                                <Td className={styles.td_amount}>{i.stakedCnr}</Td>
                                <Td className={styles.td_amount}>{(balances?.bonusRewardPool * 0.4 / leaderBoard.list.length).toFixed(2)}</Td>
                            </Tr>
                        )
                    })}
                </Tbody>
            </Table>
        </div>
    )
}
